export default __webpack_public_path__ + "static/media/mission-img2.19fa08f0.jpg";